/* Component Dependencies */
var discountsAndSavingsTemplate = require('templates/discountsAndSavings.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'discountsAndSavings',
  template: {
    'discountsAndSavings': discountsAndSavingsTemplate
  }
});
